if (!customElements.get('bundle-addon')) {
  customElements.define(
    'bundle-addon',
    class BundleAddon extends HTMLElement {
      cartUpdateUnsubscriber = undefined;

      connectedCallback() {
        this.checkbox = this.querySelector('.buy-box-bundle-addon__check');
        this.priceTarget = this.querySelector('[data-addon-price]');
        this.totalTarget = this.querySelector('[data-addon-total]');

        const variantData = this.querySelector('[data-addon-variants]');
        if (!this.checkbox || !variantData) return;

        try {
          this.entries = JSON.parse(variantData.textContent);
        } catch (error) {
          return;
        }

        this.form = document.getElementById(`product-form-${this.dataset.sectionId}`);
        this.variantInput = this.form ? this.form.querySelector('input[name="id"]') : null;
        if (!this.variantInput) return;

        this.baseVariantId = this.variantInput.value;
        this.quantityInput = document.getElementById(`Quantity-${this.dataset.sectionId}`);
        if (this.quantityInput) this.quantityInput.addEventListener('change', this.apply.bind(this));

        this.checkbox.addEventListener('change', this.apply.bind(this));

        // VariantSelects.updateVariantInput() (global.js) hard-sets this input to
        // the newly selected variant and dispatches a bubbling change event. That
        // is the signal to re-map and re-apply; setting .value ourselves never
        // fires change, so this listener only ever hears the theme's own writes.
        this.variantInput.addEventListener('change', this.onVariantInputChange.bind(this));

        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.onCartUpdate.bind(this));

        this.apply();
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) this.cartUpdateUnsubscriber();
      }

      get entry() {
        return this.entries[this.baseVariantId];
      }

      onVariantInputChange() {
        const value = this.variantInput.value;
        // Anything that is not one of this product's own variants is the bundle
        // variant we swapped in, so there is nothing to re-map.
        if (!Object.prototype.hasOwnProperty.call(this.entries, value)) return;

        this.baseVariantId = value;
        this.render();
        this.apply();
      }

      onCartUpdate(event) {
        if (!event || !event.data || event.data.source !== 'product-form') return;
        if (!this.checkbox.checked) return;

        // Reset after a successful add so the next add-to-cart doesn't silently
        // repeat the bundle.
        this.checkbox.checked = false;
        this.apply();
      }

      render() {
        const entry = this.entry;
        const usable = Boolean(entry && entry.id && entry.available);

        this.checkbox.disabled = !usable;
        if (!usable) this.checkbox.checked = false;

        if (!this.priceTarget) return;

        if (!usable) {
          this.priceTarget.innerHTML =
            '<span class="buy-box-bundle-addon__unavailable">Unavailable with this option</span>';
          return;
        }

        const saving = entry.saving
          ? ` <span class="buy-box-bundle-addon__save">save ${entry.saving}</span>`
          : '';
        this.priceTarget.innerHTML = `+${entry.delta}${saving}`;
      }

      apply() {
        const entry = this.entry;
        const usable = Boolean(entry && entry.id && entry.available);
        const active = usable && this.checkbox.checked;

        this.variantInput.value = active ? entry.id : this.baseVariantId;
        this.toggleAttribute('data-addon-active', active);

        if (!this.totalTarget) return;

        if (!active) {
          this.totalTarget.hidden = true;
          this.totalTarget.innerHTML = '';
          return;
        }

        const quantity = this.quantityInput ? parseInt(this.quantityInput.value, 10) || 1 : 1;
        const label = quantity > 1 ? 'Bundle price' : 'Bundle total';
        const each = quantity > 1 ? ' each' : '';
        const bundleTitle = this.dataset.bundleTitle;
        const applied = bundleTitle ? ` · ${bundleTitle} pricing applied` : '';

        this.totalTarget.innerHTML = `${label}: <strong>${entry.total}</strong>${each}${applied}`;
        this.totalTarget.hidden = false;
      }
    }
  );
}
